import Hightlighter from 'react-highlight-words';
import { DotMenu, AppStatus, ImageWithFallback, CopyString } from 'components';
import EmptyIcon from 'assets/images/EmptyIcon.svg';
import { subdirectory } from 'utils';

import * as S from './ApplicationsTable.styled';

export default function ApplicationsTable({ appList = [], searchValue, isRedirect$ }) {
  return (
    <>
      <S.Header>
        <div></div>
        <div>Applications</div>
        <div>Status</div>
      </S.Header>
      <S.TableBody>
        <div>
          {appList.length ? (
            appList.map((item, ind) => (
              <TableRow data={item} searchValue={searchValue} isRedirect$={isRedirect$} key={ind} />
            ))
          ) : (
            <S.NoData>No data found</S.NoData>
          )}
        </div>
      </S.TableBody>
    </>
  );
}

function TableRow({ data, searchValue, isRedirect$ }) {
  return (
    <S.Row>
      <S.DotMenuWrap>
        <DotMenu pba_id={data.pba_id} is_deleted={data.is_deleted} isRedirect$={isRedirect$} />
      </S.DotMenuWrap>
      <S.ApplicationColumn>
        <S.IconWrap isArchived={data.status === 'archived'}>
          <ImageWithFallback
            src={`https://cdn.appnext.com/${subdirectory(data.image_url)}/${data.image_url}`}
            fallbackSrc={EmptyIcon}
          />
          {data.app_type_assoc && <S.WwwTag>WWW</S.WwwTag>}
        </S.IconWrap>
        <div>
          <S.AppTitle>
            <Hightlighter
              textToHighlight={data.pba_name}
              searchWords={[searchValue]}
              highlightTag='strong'
              autoEscape={true}
            />
          </S.AppTitle>
          <S.IDWrap>
            <span>ID: </span>
            <Hightlighter
              textToHighlight={data.pba_number + ''}
              searchWords={[searchValue]}
              highlightTag='strong'
              autoEscape={true}
            />
            <CopyString label='' text={`${data.pba_number}`} isHidden={true} />
          </S.IDWrap>
        </div>
      </S.ApplicationColumn>
      <AppStatus {...data} isRedirect$={isRedirect$} />
    </S.Row>
  );
}
